import type { WizardField } from './types';
import { CONTACT_MEDIA_OPTIONS } from '../components/editor2/constants';

/**
 * 優先順位:
 *   必須   → customer_name
 *   準必須 → phone, email
 *   その他 → NOC, CDW, pax, シート, 便名, comment
 *
 * 超必須（pickup/return/vehicle_type）は Gemini チャットで先に揃えるため、ウィザードには含まない。
 */
export const RESERVATION_WIZARD_FIELDS: WizardField[] = [
  // 必須
  { key: 'customer_name', label: '予約者名', question: '予約者名を教えてください', inputType: 'text', placeholder: '例: 田中 太郎', required: true },
  // 準必須（連絡先）
  { key: 'phone', label: '電話', question: '電話番号を教えてください', inputType: 'text', placeholder: '例: 090-0000-0000', skipLabel: '不明' },
  { key: 'email', label: 'メール', question: 'メールアドレスを教えてください', inputType: 'text', placeholder: '例: example@example.com', skipLabel: '不明' },
  // 予約経路（2026-10-19 前田さん: エージェントから作った予約にも予約経路を残す）。サイドパネルと同じ候補
  { key: 'contact_media', label: '予約経路', question: '予約経路は？（TEL・直来・LINE など）', inputType: 'select',
    options: [...CONTACT_MEDIA_OPTIONS], placeholder: '例: TEL' },
  // 補償
  { key: 'noc_waiver', label: 'NOC', question: 'NOC免責はつけますか？', inputType: 'yes_no' },
  { key: 'cdw', label: 'CDW', question: 'CDW（車両損害補償）はつけますか？', inputType: 'yes_no' },
  // 乗車人数・シート
  { key: 'pax', label: '大人', question: '乗車人数（大人）は何名ですか？', inputType: 'number', placeholder: '例: 4' },
  { key: 'pax_children', label: '子供', question: '子供の人数は何名ですか？（0=なし）', inputType: 'number' },
  { key: 'child_seat', label: 'チャイルドシート', question: 'チャイルドシートの必要数は？（0=なし）', inputType: 'number' },
  { key: 'booster_seat', label: 'ブースター', question: 'ブースターシートの必要数は？（0=なし）', inputType: 'number' },
  // 便名
  { key: 'arrival_flight', label: '到着便', question: '到着便名はありますか？', inputType: 'text', placeholder: '例: NH123', skipLabel: 'なし' },
  { key: 'departure_flight', label: '出発便', question: '出発便名はありますか？', inputType: 'text', placeholder: '例: JL987', skipLabel: 'なし' },
  // 要望
  { key: 'comment', label: '要望', question: 'お客様の要望・ご希望はありますか？', inputType: 'text', placeholder: '例: 後部座席を広くしたい' },
];

export function formatWizardAnswer(field: WizardField, value: any): string {
  if (value === null || value === undefined || value === '') return '（スキップ）';
  if (field.inputType === 'yes_no') return value === true ? 'はい' : 'いいえ';
  if (field.inputType === 'number') return `${value}`;
  return String(value);
}

/**
 * 複数台予約のときだけ聞く: 請求書をまとめるか（2026-10-19 前田さん）。
 * まとめる = グループで1枚の Square 請求書（下書き）を作り、全台の予約に同じ請求書を結ぶ（md/multi-vehicle.md）
 */
export const INVOICE_GROUPING_FIELD: WizardField = {
  key: 'invoice_grouping', label: '請求書', question: '複数台の予約です。請求書をまとめますか？',
  inputType: 'select', options: ['1枚にまとめる', '台ごとに分ける'], required: true,
};
